export const SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
}

export const CONTROL_SIZES = {
    [SIZES.XS]: 7,
    [SIZES.SM]: 9,
    [SIZES.MD]: 11,
    [SIZES.LG]: 14
}

export const LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline'
}

export const DIRECTIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
}

export const SELECTION_MODES = {
	YEAR: 'year',
	MONTH: 'month',
	DAY: 'day'
}

export const PICKER_VIEWS = {
	YEAR: 'year',
	MONTH: 'month',
	DATE: 'date',
}

export const STATUS = {
    DANGER: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning'
}

export const STEPS_STATUS = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    ERROR: 'error'
}

export const PLACEMENT = {
    TOP_START: 'top-start',
    TOP_CENTER: 'top-center',
    TOP_END: 'top-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_END: 'bottom-end',
    MIDDLE_START_TOP: 'middle-start-top',
    MIDDLE_START_BOTTOM: 'middle-start-bottom',
    MIDDLE_END_TOP: 'middle-end-top',
    MIDDLE_END_BOTTOM: 'middle-end-bottom'
}

export const DROPDOWN_ITEM_TYPE = {
    DEFAULT: 'default',
    HEADER: 'header',
    DIVIDER: 'divider',
    CUSTOM: 'custom',
}

export const DELIVERY_EXPECTATION_TRANSLATIONS = {
    'Delivery under an hour': 'Under an hour',
    'Delivery in 60-90 minutes': '60 - 90 min',
    'Delivery in 60-120 Minutes': '60 - 120 min',
    'Delivery in 90-120 Minutes': '90 - 120 min',
    'Delivery in 2-2.5 hours': '2 - 2.5 hrs',
    'Delivery in 2.5-3 hours': '2.5 - 3 hrs',
    'Shipment': 'Ships in 1 - 2 days',
    'Shipment (1-3 business days)': 'Ships in 1 - 3 days',
    'Shipment (2 business days)': 'Ships in 2 days',
    'Shipment (3-7 business days)': 'Ships in 3 - 7 days',
    'Usually ships within 1-2 business days': 'Ships in 1 - 2 days',
    'Usually ships within 1-3 business days': 'Ships in 1 - 3 days',
    'Usually ships within 3-7 business days': 'Ships in 3 - 7 days',
    'Limited Availability: Usually ships within 1-2 weeks': '1 - 2 weeks',
    'In-store pickup': 'In-store pickup',
    'Instant delivery': 'Instant delivery'
}

export const DAY_DURATION = 86400000;

export const ENGRAVING_TYPE = 2;